<template>
  <div class="flex flex-col text-block gap-4">
    <ToggleSwitchCardItem
      v-for="item in items"
      :id="item.id"
      :key="item.id"
      :title="item.title"
      :description="item.description"
      :modelValue="item.modelValue"
      :disabled="item.disabled"
      @change="(payload) => emit('update', payload)"
    />
  </div>
  <InformationBox
    v-if="allDisabled && disabledAllMessage"
    class="mt-6"
    :description="disabledAllMessage"
    :type="InformationBoxTypes.WARNING"
  />
</template>

<script setup lang="ts">
import { computed } from 'vue';
import ToggleSwitchCardItem from './ToggleSwitchCardItem.vue';
import InformationBox from '@/components/InformationBox/InformationBox.vue';
import { InformationBoxTypes } from '@/interfaces/forms/information-box.interface';
import { IToggleSwitchCardItem } from '@/interfaces/components/toggle-switch-card.interface';

// Receive items array from parent
const props = defineProps<{ items: IToggleSwitchCardItem[]; disabledAllMessage?: string }>();

// Emit whenever a toggle changes
const emit = defineEmits<{
  (e: 'update', payload: { id: string; value: boolean }): void;
}>();

// Computed → are all toggles disabled?
const allDisabled = computed(() => props.items.length > 0 && props.items.every((i) => i.modelValue == false));
</script>
